var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaeces = function SvgFaeces(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Faeces_svg__st0{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.6c12.9 0 23.4 10.5 23.4 23.4S44.9 55.4 32 55.4 8.6 44.9 8.6 32 19.1 8.6 32 8.6M32 7C18.2 7 7 18.2 7 32s11.2 25 25 25 25-11.2 25-25S45.8 7 32 7",
    className: "Faeces_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 34.8c-.2-.2-.4-.4-.5-.7-.9-1.3-.9-2.9.1-4s2.6-1.4 3.9-.6c2.9 1.8 6.1 2.5 9.3 2.9 1.5.2 2.8.5 3.5 2.1.1.3.5.5.8.7 2.3 1.6 2.3 4.5-.3 5.6-2.4 1-5.1 1.6-7.7 1.9-3.8.5-7.5-.1-11-1.6-1.3-.5-2.3-1.4-2.4-2.9 0-1.3.4-2.4 1.6-2.9.8-.4 1.7-.4 2.7-.5M30.2 28.8c1.4-.4 1.7-1.4 1.8-2.7.1-3 1.6-4.5 4.6-4.9-1.4 1.4-.7 2.5.3 3.6 1.4 1.4 2.2 3.1 1.9 5.1-.1 1-.5 1.5-1.6 1.3-2.4-.6-4.7-1.2-7.1-1.8.1-.2.1-.4.1-.6",
    className: "Faeces_svg__st0"
  })));
};
export default SvgFaeces;